import { BookingOrGuest } from '@website/components/BookingCard';
import { UserDashboardQuery } from '@website/types/graphqlOperations';

/**
 *
 * combineGuestBookingWithUserBookingsAndSort
 *
 * takes an array of bookings and an array of guestOnBookings and combines them,
 * ensuring that no duplicates are present. The reason for duplicates is because
 * it is possible for user to be a guest in their bookings hence appearing twice.
 *
 */
export function combineGuestBookingWithUserBookingsAndSort(
  guestOnBookings: UserDashboardQuery['user']['guestOnBookings']['items'][0]['booking'][],
  userBookings: UserDashboardQuery['user']['bookings']['items'],
): BookingOrGuest[] {
  // filter out duplicate bookings
  const filterGuestOnBookingsBookings = guestOnBookings.filter((booking) => {
    if (userBookings.find((userBooking) => userBooking.id === booking.id)) {
      return false;
    }
    return true;
  });
  // combine the remaining bookings
  const combineBookingsAndGuests = [
    ...filterGuestOnBookingsBookings,
    ...userBookings,
  ];
  // Date sort
  return combineBookingsAndGuests.sort((a, b) => {
    return (
      new Date(a.group.start.utc).getTime() -
      new Date(b.group.start.utc).getTime()
    );
  });
}
